import OptimizerEditDto from "./OptimizerEditDto";

export class SLSQPOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.eps = null;
        /** @type {number} */
        this.ftol = null;
        /** @type {number} */
        this.tol = null;
    }

    /**
     * @typedef {Object} _SLSQPOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} eps
     * @property {number} ftol
     * @property {number} tol
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _SLSQPOptimizerEditDtoProps} SLSQPOptimizerEditDtoProps
     */
    /**
     * 
     * @param {SLSQPOptimizerEditDtoProps} props
     * @returns {SLSQPOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.eps = props.eps;
        this.ftol = props.ftol;
        this.tol = props.tol;
        return this;
    }
}

export default SLSQPOptimizerEditDto;